import React from 'react'
import { phq9_catalog } from '../../../../escalas/phq9p/phq9p.catalog'

const phq9_catalog_values = [
    "No del todo",
    "Varios días",
    "Más de la mitad de los días",
    "Casi todos los días"
]

function getPhq9Interpretation(score) {
    if (score <= 4) return 'Mínima depresión'
    if (score <= 9) return 'Depresión leve'
    if (score <= 14) return 'Depresión moderada'
    if (score <= 19) return 'Depresión moderada-grave'
    return 'Depresión grave'
}

export default function Phq9Results({ phq9 }) {
    if (!phq9) return null

    const score = phq9.reduce((a, v) => a + v, 0)

    return (
        <div>
            <tr style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: '#e6f4ff', padding: 5, borderRadius: 6 }}>
                <td><strong>Puntuación total: {score} / 27</strong></td>
                <td><strong>{getPhq9Interpretation(score)}</strong></td>
            </tr>
            {
                phq9_catalog.map((item, index) => (
                    <tr key={index} style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#fff', padding: 5, borderRadius: 6 }}>
                        <td>{item}</td>
                        <td>{phq9_catalog_values[phq9[index]]}</td>
                    </tr>
                ))
            }
        </div>
    )
}
